<script setup lang="ts">
import { Button } from '@/components/ui/button';
import useWorkflow from '@/composables/useWorkflow.ts';

defineProps<{
    title: string;
    handle: string;
}>();

const { start } = useWorkflow();
</script>

<template>
    <Button
        @click="() => start(handle, title)"
        variant="outline"
    >
        <slot />
    </Button>
</template>
